import { render, staticRenderFns } from "./sparepartHistoyModal.vue?vue&type=template&id=b6bc5eb4"
import script from "./sparepartHistoyModal.vue?vue&type=script&lang=js"
export * from "./sparepartHistoyModal.vue?vue&type=script&lang=js"
import style0 from "./sparepartHistoyModal.vue?vue&type=style&index=0&id=b6bc5eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports